export const TITLE =
  'Apply for D.I.C., Survivors Pension, or accrued benefits online';
export const SUBTITLE =
  'For spouses and children of deceased Veterans only (VA Form 21P-534EZ)';

export const API_ENDPOINTS = {
  facilities: '/survivors_benefits/v0/facilities/',
};
